import { render } from "./jmedit.vue?vue&type=template&id=7ddd8c87&scoped=true"
import script from "./jmedit.vue?vue&type=script&lang=js"
export * from "./jmedit.vue?vue&type=script&lang=js"

import "./jmedit.vue?vue&type=style&index=0&id=7ddd8c87&lang=scss&scoped=true"
import "./jmedit.vue?vue&type=style&index=1&id=7ddd8c87&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddd8c87"]])

export default __exports__